<template>
  <div class="color-picker" v-click-outside="hidePopover">
    <Field
      type="text"
      :label="label"
      :id="id"
      :name="name"
      :disabled="disabled"
      :readonly="readonly"
      :placeholder="placeholder"
      :validate="validate"
      :validateAs="validateAs"
      :errorText="errorMessage"
      :helpText="helpText"
      :elementClass="elementClass"
      :labelClass="labelClass"
      :inputClass="inputClass"
      :inputStyle="inputStyle"
      :value="hex"
      @change="inputChanged"
      @focus="showPopover = true"
    />
    <div v-show="showPopover" class="cp-popover">
      <div class="row no-gutters">
        <div class="col-2 mb-2">
          <span class="cp-popover-label">Hex:</span>
        </div>
        <div class="col-10 mb-2">
          <input class="cp-popover-input" type="text" v-model="hex" />
        </div>
        <div class="col-2">
          <span class="cp-popover-label">RGB:</span>
        </div>
        <div class="col-10">
          <span class="cp-popover-prefix">R</span>
          <input class="cp-popover-input short" type="text" v-model="red" />
          <span class="cp-popover-prefix">G</span>
          <input class="cp-popover-input short" type="text" v-model="green" />
          <span class="cp-popover-prefix">B</span>
          <input class="cp-popover-input short" type="text" v-model="blue" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Color from "helpers/Color";
import InputFieldProps from "mixins/InputFieldProps";
export default {
  mixins: [InputFieldProps],
  props: {
    value: { type: String }
  },
  data() {
    return {
      hex: "FFFFFF",
      red: 255,
      green: 255,
      blue: 255,
      invalidInput: false,
      showPopover: false,
      pausePropagation: false
    };
  },
  computed: {
    errorMessage() {
      return this.invalidInput
        ? "Please enter a valid hexidecimal value (e.g. FFFFFF)"
        : this.errorText;
    },
    inputStyle() {
      var bg = Color.isHex(this.hex) ? `#${this.hex}` : "#FFFFFF";
      var color = Color.isHex(this.hex) ? this.inputTextColor : "#222222";
      return `background-color:${bg}; color:${color};`;
    },
    inputTextColor() {
      return Color.yiq(this.hex);
    }
  },
  watch: {
    value(val) {
      if (Color.isFullHex(val)) {
        this.hex = val;
      }
    },
    hex(val) {
      this.$emit("input", val);
      if (!this.pausePropagation) {
        this.calculateRGBFromHex();
      }
    },
    red(val) {
      if (!this.pausePropagation) {
        this.calculateHexFromRGB();
      }
    },
    green(val) {
      if (!this.pausePropagation) {
        this.calculateHexFromRGB();
      }
    },
    blue(val) {
      if (!this.pausePropagation) {
        this.calculateHexFromRGB();
      }
    }
  },
  methods: {
    calculateHexFromRGB() {
      this.pausePropagation = true;
      this.hex = Color.rgb2hex(this.red, this.green, this.blue);
      this.$nextTick(() => {
        this.pausePropagation = false;
      });
    },
    calculateRGBFromHex() {
      this.pausePropagation = true;
      this.red = Color.red(this.hex);
      this.green = Color.green(this.hex);
      this.blue = Color.blue(this.hex);
      this.$nextTick(() => {
        this.pausePropagation = false;
      });
    },
    inputChanged(val) {
      if (!Color.isFullHex(val)) {
        this.invalidInput = true;
      } else {
        this.hex = val.toUpperCase();
        this.calculateRGBFromHex();
        this.invalidInput = false;
      }
    },
    hidePopover() {
      this.showPopover = false;
    }
  },
  mounted() {
    if (!!this.value && Color.isFullHex(this.value)) {
      this.hex = this.value;
    }
  }
};
</script>

<style lang="scss" scoped>
.color-picker {
  position: relative;
  .cp-popover {
    background-color: #ffffff;
    box-shadow: 0 2px 10px -2px #999999;
    padding: 1rem;
    width: 320px;
    position: absolute;
    z-index: 9999;
  }
  .cp-popover-label,
  .cp-popover-prefix {
    display: inline-block;
    font-size: 0.75rem;
    text-transform: uppercase;
  }
  .cp-popover-prefix {
    text-align: right;
    width: 7%;
  }
  .cp-popover-input {
    display: inline-block;
    font-size: 0.75rem;
    width: 100%;
    &.short {
      width: 24%;
    }
  }
}
</style>